/**
 * Persistent affiliate disclosure banner shown on every KIT screen.
 * Copy is verbatim as approved. Small, muted, never dismissible so
 * users are always aware while browsing.
 *
 * Iter-158.13.2.20f.30 — Disclosure re-attributed from first-person
 * to OnSetFlow-as-the-Associate. Real-iPhone human review noted
 * that "I earn from qualifying purchases" implies the individual
 * user/creator is personally the Amazon Associate. The Associate
 * is OnSetFlow. Copy-only change; affiliate URLs, tags and
 * referral parameters are UNTOUCHED.
 */
export function KitAffiliateDisclosure() {
    return (
        <p
            data-testid="kit-affiliate-disclosure"
            className="text-[11px] text-neutral-500 text-center leading-relaxed mt-8 mb-2"
        >
            OnSetFlow is an Amazon Associate and earns from qualifying purchases.
        </p>
    );
}
